import React from "react";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  tableContainerStyles,
  tableStyles,
  tableCellStyles,
  tableRowStyles,
} from "../style";

const Tabel = () => {
  return (
    <TableContainer sx={tableContainerStyles}>
      <Table sx={tableStyles} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell colSpan={2} sx={tableCellStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>Series</span>
              </Typography>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>94-54</span>
              </Typography>
            </TableCell>

            {/* <TableCell align="right">Fat&nbsp;(g)</TableCell> */}
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>104-68</span>
              </Typography>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>115-62</span>
              </Typography>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>140-90</span>
              </Typography>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>151-90</span>
              </Typography>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>152-101</span>
              </Typography>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>164-101</span>
              </Typography>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>214-152</span>
              </Typography>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>152-101</span>
              </Typography>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>213-152</span>
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Casing&nbsp;(in)</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4&nbsp;1/2</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5&nbsp;1/2</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>6&nbsp;5/8</span>
            </TableCell>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>7</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>7&nbsp;5/8</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>9&nbsp;5/8</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>7</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>9&nbsp;5/8</span>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Weight&nbsp;(ppf)</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>9.5-11.6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>13-15</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>15.5-20</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>24-28</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>26-29</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>23-29</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>29.7-33.7</TableCell>
            <TableCell sx={tableRowStyles}>
              <span>40-47</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>26-29</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>40-47</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tableRowStyles} rowSpan={2}>
              <span>Max&nbsp;OD</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>(mm)</span>
            </TableCell>

            <TableCell sx={tableRowStyles}>
              <span>94</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>104</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>115</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>140</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>151</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>152</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>164</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>214</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>152</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>213</span>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={tableRowStyles}>
              <span>(in)</span>
            </TableCell>

            <TableCell sx={tableRowStyles}>
              <span>3.7</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4.09</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4.53</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5.51</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5.9</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5.98</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>6.45</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>8.43</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5.98</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>8.39</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tableRowStyles} rowSpan={2}>
              <span>Min&nbsp;ID</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>(mm)</span>
            </TableCell>

            <TableCell sx={tableRowStyles}>
              <span>54</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>68</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>62</span>
            </TableCell>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>90</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>101.6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>101.6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>152</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>101.6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>152</span>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={tableRowStyles}>
              <span>(in)</span>
            </TableCell>

            <TableCell sx={tableRowStyles}>
              <span>2.13</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>2.68</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>2.44</span>
            </TableCell>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>3.54</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5.98</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5.98</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Setting Pressure&nbsp;(psi)</span>
            </TableCell>
            <TableCell colSpan={10} sx={tableRowStyles}>
              <span>1700-2600</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Pressure Grade&nbsp;(psi)</span>
            </TableCell>
            <TableCell colSpan={4} sx={tableRowStyles}>
              <span>7000</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>10000</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5000</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>10000</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5000</span>
            </TableCell>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>10000</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Temperature Rating&nbsp;(℃)</span>
            </TableCell>
            <TableCell colSpan={10} sx={tableRowStyles}>
              <span>120/150/180</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Top Thread</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>2 7/8NU</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>3</span>
              <br />
              <span>1/2 NU</span>
            </TableCell>

            <TableCell sx={tableRowStyles}>
              <span>2</span>
              <br />
              <span>7/8 NU</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>RM95×6</span>
            </TableCell>
            <TableCell colSpan={3} sx={tableRowStyles}>
              <span>RM106×6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>RM158×6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>RM115×6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>RM168×6</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Top Thread</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>2 7/8NU</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>3</span>
              <br />
              <span>1/2 NU</span>
            </TableCell>

            <TableCell sx={tableRowStyles}>
              <span>2</span>
              <br />
              <span>7/8 NU</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4〞NU</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4</span>
              <br />
              <span>1/2″ LTC</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5″ LTC</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4</span>
              <br />
              <span>1/2″ LTC</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>7″ LTC</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>M128×2.5</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>M182×3</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Setting</span>
            </TableCell>
            <TableCell colSpan={10} sx={tableRowStyles}>
              <span>Hydraulic</span>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Release</span>
            </TableCell>
            <TableCell colSpan={10} sx={tableRowStyles}>
              <span>Retrieving Tool</span>
            </TableCell>
          </TableRow>

        
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Tabel;
